<script>
import axios from 'axios';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import reloginMixin from '@/mixins/relogin';
import { rbxAuthToken } from '../../config';
import FeedbackButton from './feedbackButton';

export default {
  components: {
    FeedbackButton,
  },
  mixins: [reloginMixin],
  data() {
    return {
      defaultLogoPath: '',
      isLutopUrl: false,
      logo: {
        path: '',
        id: null,
      },
      isReloginButtonDisplayed: false,
    };
  },
  computed: {
    ...mapGetters('app', ['currentUser']),
  },
  created() {
    const url = window.location.origin;
    const lowerCaseUrl = url.toLowerCase();

    if (lowerCaseUrl.indexOf('lutop') !== -1) {
      this.defaultLogoPath = '../../assets/logos/LUTOP_Logo_System.svg';
      this.isLutopUrl = true;
    } else {
      this.defaultLogoPath = '../../assets/logos/LOGO_WHITELABEL.svg';
      this.isLutopUrl = false;
    }
  },
  mounted() {
    axios.get('/company')
      .then((res) => {
        const reseller = res.data && res.data.length > 0 ? res.data[0].reseller : null;
        const companyLogo = res.data && res.data.length > 0 ? res.data[0].logo : null;

        if (companyLogo) {
          this.logo = companyLogo;
        } else if (reseller && reseller.logo) {
          this.logo = reseller.logo;
        } else {
          this.logo.path = this.defaultLogoPath;
          this.logo.id = null;
        }
      });
    axios.get('/user?current=true')
      .then((res) => {
        if (res.data.isNewPasswordRequired) {
          this.$router.push('/logout');
        }
        if (res.data.createdById && (res.data.isReseller || res.data.isResellerAgent)) {
          this.isReloginButtonDisplayed = true;
        }

        this.setUser(res.data);
      });
  },
  methods: {
    ...mapActions('app', ['toggleDrawer']),
    ...mapMutations('app', ['setUser']),
    onLogin() {
      axios.get('/user/reseller')
        .then((res) => {
          this.relogin(res.data.username, rbxAuthToken);
        });
    },
  },
};
</script>

<template>
  <v-toolbar dense app absolute clipped-left color="white">
    <v-toolbar-side-icon @click.native="toggleDrawer"/>
    <v-img v-if="logo.path !== '' && logo.id != null"
           :src="logo.path + '?logoId=' + logo.id"
           :max-height="48" :max-width="120"
    />
    <v-img v-else-if="logo.path !== '' && logo.id == null && isLutopUrl"
           :src="require('../../assets/logos/LUTOP_Logo_System.svg')"
           style="max-height:48px;" class="rbxmainlogo"
    />
    <v-img v-else-if="logo.path !== '' && logo.id == null"
           :src="require('../../assets/logos/LOGO_WHITELABEL.svg')"
           style="max-height:48px;" class="rbxmainlogo"
    />

    <div style="font-size: 12px; margin-left: 15px !important;">
      <span style="font-weight:500; color: #666; padding-left: 28px;">Eingeloggt:</span>
      &nbsp;<v-chip color="#31AB44" text-color="#fff" small>{{ this.currentUser }}</v-chip>
    </div>

    <v-spacer/>

    <v-tooltip v-if="isReloginButtonDisplayed" bottom>
      <v-btn @click.native="onLogin()" icon slot="activator">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <span>Zurück zum Reseller-Portal</span>
    </v-tooltip>
    <feedback-button />
  </v-toolbar>
</template>
<style lang="scss" scoped>
.rbxmainlogo {
  max-width:130px;
  margin-right:20px
}
</style>
